import {useTitle} from 'hooks';
import {useParams} from 'react-router-dom';

import AssetsMine from './components/Assets.Mine';

interface IPageAssetsProps {}

const PageAssets = ({}: IPageAssetsProps) => {
  useTitle('Assets');

  const params = useParams();
  const workspace = params.workspace;

  if (workspace === 'me') {
    return <AssetsMine />;
  }

  return null;
};

export default PageAssets;
